
import { ErrorsTranslationType } from "../../features/errors.types";

export const errors: ErrorsTranslationType = {
  errors: {
    error: "Fehler",
    notFound: "Seite nicht gefunden",
    deleteAccountError: "Fehler beim Löschen des Kontos. Bitte versuchen Sie es erneut.",
    loadStoryError: "Fehler beim Laden der Geschichte. Bitte versuchen Sie es erneut.",
    loadCharactersError: "Fehler beim Laden der Charaktere. Bitte versuchen Sie es erneut.",
    summaryError: "Fehler beim Generieren der Zusammenfassung. Bitte versuchen Sie es erneut."
  }
};
